
import vue from "vue";
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import CustomService from "./menu";
import {
getHeadInfo,
getWelfareList,
getActivityList,
initWxJSSDK
} from "../common/js/api.js";
import { getCookie, setCookie } from "../common/js/utils";
import { bannerList, baseUrl } from "../common/js/config";
import wx from "weixin-js-sdk";

export default {
components: {
Flexbox,
FlexboxItem,
Grid,
GridItem,
Swiper,
SwiperItem,
Tabbar,
TabbarItem,
XButton,
Group,
Cell,
CustomService
},
data() {
return {
bannerList: bannerList,
showServiceMenu: true,
dataWelfareSource: [],
pageWelfareOption: {
pageIndex: 1,
pageSize: 1,
extInfo: {}
},
pageInfo: {
pageIndex: 1,
pageSize: 1,
keyword: "",
extInfo: undefined
},
















entity: {


carbon: 0,
beans: 0,
love: 0
},
authorizer_appid: "",
dataSource: []
};
},
computed: {
path() {
return this.$route.path;
}
},
created() {
const headInfo = JSON.parse(getCookie("headInfo")) || "";

this.getActivity();
if (!headInfo) {
this.getHeadInfoHandle();
} else {


this.entity.carbon = headInfo.carbon || this.entity.carbon;
this.entity.beans = headInfo.beans || this.entity.beans;
this.entity.love = headInfo.love || this.entity.love;
}

},
mounted() {
initWxJSSDK();
},
methods: {





goActivity(activityId) {
this.$router.push({
path: "/activity/detail",
query: { activityId: activityId }
});
},

WelfareActivityDetail(activityId) {
const self = this;
wx.miniProgram.navigateTo({
url: "/pages/welfareDetail?activityId=" + activityId,
fail: () => {
self.$vux.toast.text("近期开放，敬请留意!", "middle");
}
});
},

shopIndex() {
const self = this;

wx.miniProgram.navigateTo({
url:"/pages/index",
fail: () =>  {
self.$vux.toast.text('近期开放，敬请留意!', 'middle')
}
})
},










getHeadInfoHandle() {
let self = this;
getHeadInfo().then(function(data) {
const content = data.Content;


self.entity.carbon = content.carbon || self.entity.carbon;
self.entity.beans = content.beans || self.entity.beans;
self.entity.love = content.love || self.entity.love;
setCookie("headInfo", JSON.stringify(data.Content));

});
},










getActivity() {
let self = this;
getActivityList({ data: this.pageInfo }).then(function(data) {
self.dataSource = data.Content;
});
},



reCycleBinScan() {
initWxJSSDK();
this.$wechat.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function(res) {
var result = res.resultStr; 
}
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/Main.vue